import { generateWorkdays } from './work-day-calculator';
import { isoDateString } from './date-utils';
import { getJobOrderByCalendarId, updateJobOrder } from '../services/job-order-service';

// Firestore update that puts a job on the calendar: `duration` work days
// (weekends/holidays skipped) starting at `startDate`, status → scheduled.
// Shared by the Assign Job sheet and the calendar's drag-and-drop dialog.
export function buildScheduleUpdate(job, startDate, duration, assignedCrew = null) {
  const isOnHold = job.status === 'on_hold';
  const wasInProduction = job.status === 'in_production';

  const newWorkDays = generateWorkdays(startDate, duration).map(date => ({
    id: isoDateString(date),
    date,
    status: 'planned',
    note: null,
    createdAt: new Date()
  }));

  // If job was on hold, preserve the "on_hold" workDay and add new ones
  const workDays = isOnHold && job.workDays?.length
    ? [...job.workDays.filter(wd => wd.status === 'on_hold'), ...newWorkDays]
    : newWorkDays;

  const dateLabel = startDate.toLocaleDateString();
  return {
    scheduledDate: startDate,
    durationDays: duration,
    assignedCrew: assignedCrew || null,
    workDays,
    status: 'scheduled',
    statusHistory: [
      ...(job.statusHistory || []),
      {
        status: 'scheduled',
        timestamp: new Date(),
        note: isOnHold
          ? `Rescheduled from on-hold to ${dateLabel}`
          : wasInProduction
            ? `Scheduled for ${dateLabel} (moved from in production)`
            : `Scheduled for ${dateLabel}`
      }
    ]
  };
}

// Move the linked job order to scheduled too (fire-and-forget).
export function markJobOrderScheduled(jobId) {
  getJobOrderByCalendarId(jobId).then(jo => {
    if (jo && jo.status === 'approved') {
      updateJobOrder(jo.id, { status: 'scheduled' }).catch(() => {});
    }
  }).catch(() => {});
}
